<script setup>
import {
    consentToVimeoEmbed,
    vimeoEmbedConsented,
    vimeoEmbedConsentFailed,
    vimeoEmbedConsentRecording,
} from '../../../../helpers/vimeoEmbedConsent';
import NonEssentialCookiesPrompt from '../../../cookie-banner/NonEssentialCookiesPrompt.vue';

const props = defineProps({
    content: {
        type: Object,
        required: true,
    }
})
</script>
<template>
    <div>
        <div class="grid-cols-3 gap-8 md:grid">
            <div class="col-span-3">
                <NonEssentialCookiesPrompt
                    v-if="!vimeoEmbedConsented"
                    class="aspect-video"
                    :saving="vimeoEmbedConsentRecording"
                    :failed="vimeoEmbedConsentFailed"
                    @consent="consentToVimeoEmbed"
                />
                <div v-else-if="content?.vimeo_video_id" style="padding:56.25% 0 0 0;position:relative;">
                    <iframe
                        class="rounded-wl"
                        :src="'https://vimeo.com/event/' + content.vimeo_video_id + '/embed'"
                        frameborder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowfullscreen
                        style="position:absolute;top:0;left:0;width:100%;height:100%;"
                    ></iframe>
                </div>
            </div>
        </div>
<!--         <div class="col-span-1">
            <iframe
                class="rounded-wl"
                :src="'https://vimeo.com/event/' + content.vimeo_video_id + '/chat'"
                width="100%"
                height="100%"
                frameborder="0"
            ></iframe>
        </div> -->
    </div>
</template>
